import styled from '@emotion/styled';
import { breakpoints, getMQ } from 'src/helpers';
import colors from 'src/styles/colors';

export const LinkStyle = { textDecoration: 'none', color: '#FFF' };

export const FooterContainer = styled.div`
  position: relative;
  overflow: hidden;
  min-height: 338px;
  width: 100%;
  background: ${colors.darkBlue};
  padding-top: 20px;
  z-index: 1;

  ${getMQ(breakpoints.m)} {
    min-height: 195px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 14px;
  width: 100%;
  max-width: 1256px;

  ${getMQ(breakpoints.m)} {
    padding: 13px 39px;
    margin: auto;
  }

  ${getMQ(breakpoints.l)} {
    padding: 49px 31px 30px 31px;
  }

  ${getMQ(breakpoints.xl)} {
    padding: 49px 0px 30px 0px;
  }
`;

export const InfoContainer = styled.div`
  flex-direction: row;
  display: flex;
  margin: 15px 0px;
`;

export const FooterBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  ${getMQ(breakpoints.m)} {
    flex-direction: row-reverse;
    justify-content: space-evenly;
  }
`;

export const JonniLogoMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 30px 0px;

  img {
    width: 184px;
    margin-bottom: 0;
  }

  ${getMQ(breakpoints.l)} {
    display: none;
  }
`;

export const JonniLogoDesktop = styled.div`
  display: none;

  ${getMQ(breakpoints.l)} {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 184px;
      margin-bottom: 0;
    }
  }
`;

export const Info = styled.div`
  color: ${colors.white};
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  margin: 0px 15px;
  &:hover {
    opacity: 0.5;
  }
`;

export const DownloadLinksWrapper = styled.div`
  margin: 15px 0px 35px 0px;

  ${getMQ(breakpoints.m)} {
    margin: 10px 0px 0px 0px;
  }

  ${getMQ(breakpoints.l)} {
    margin: 10px 0px -25px 0px;
  }
`;

export const StyledDiv = styled.div`
  position: inherit;
  z-index: 100;
`;
